
eval("define(\'text!htmlContent/code-hint-list.html\',[],function () { return \'{{#hints}}\\n    <li>\\n        <a href=\"#\">\\n            <span class=\"codehint-item\">{{{formattedHint}}}</span>\\n        </a>\\n    </li>\\n{{/hints}}\';});\n\n//# sourceURL=/text!htmlContent/code-hint-list.html");

